"use client";
'use strict';

var React = require('react');

const UserContext = React.createContext(undefined);
const UserProvider = UserContext.Provider;

exports.UserContext = UserContext;
exports.UserProvider = UserProvider;
//# sourceMappingURL=UserProvider.js.map
